"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _cookies = require('web/services/cookies');

// SAFETY: both cookies hold a JSON list of user keys, written only below.
// readCookie gives null for a missing cookie; JSON.parse('null') is null, as
// JSON.parse(null) was.
const readUserKeysCookie = (name) =>
  JSON.parse(_nullishCoalesce(_cookies.readCookie.call(void 0, name), () => ( 'null'))) 

 const hasBeenSeenOnThisMachineBefore = (userKey) => {
  const cookie = readUserKeysCookie("previousUsers")

  if (cookie == null) {
    return false
  }

  return cookie.indexOf(userKey) > -1
}; exports.hasBeenSeenOnThisMachineBefore = hasBeenSeenOnThisMachineBefore

 const addUserToPreviousLoginsList = (userKey) => {
  let cookie = readUserKeysCookie("previousUsers")

  if (cookie == null) {
    cookie = []
  }

  if (cookie.indexOf(userKey) === -1) {
    cookie.push(userKey)
  }

  _cookies.createCookie.call(void 0, "previousUsers", JSON.stringify(cookie), { years: 1 })
}; exports.addUserToPreviousLoginsList = addUserToPreviousLoginsList

 const isUserAwareOfQuickLogin = (userKey) => {
  const usersFromCookies = readUserKeysCookie('usersAwareOfQuickLogin')
  return usersFromCookies && usersFromCookies.indexOf(userKey) > -1
}; exports.isUserAwareOfQuickLogin = isUserAwareOfQuickLogin

 const addUserToAwareOfQuickLoginList = (userKey) => {
  const usersList = readUserKeysCookie('usersAwareOfQuickLogin') || []
  const updatedUsersList = usersList.indexOf(userKey) > -1
    ? usersList
    : usersList.concat(userKey)

  _cookies.createCookie.call(void 0, 'usersAwareOfQuickLogin', JSON.stringify(updatedUsersList), { years: 1 })
}; exports.addUserToAwareOfQuickLoginList = addUserToAwareOfQuickLoginList
